export enum BackupStatus {
    INPROGRESS = "In progress",
    CANCELLED = "Cancelled",
    COMPLETED = "Complete"
}